import { Grid, GridItem, Text, useColorModeValue } from '@telescope/cassini-ui';
import { useTheme } from '@telescope/cassini-hooks';
// TODO: support custom headline copy
export const BingoHeadline = () => {
  const copy = 'BINGO';

  const theme = useTheme();
  const { defaultColorScheme: c } = theme.settings;
  const color = useColorModeValue(`${c}.900`, `${c}.50`);
  
  return (
    <Grid templateColumns={`repeat(${copy.length}, 1fr)`}>
      {copy.split('').map((letter, i) => (
        <GridItem key={i}>
          <Text align="center" fontSize={{base: '5xl', lg: '6xl'}} fontWeight="800" lineHeight={1} color={color}>{letter}</Text>
        </GridItem>
      ))}
    </Grid>
  )
}